module.exports = __webpack_public_path__ + "static/media/email-confirm.72cab717.svg";